import { useEffect, useContext, useState } from 'react';

import { Grid, Typography, Button, TextField } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';

import { ViewerComponent } from '../commons/viewer/viewer.component';
import { login } from '../../services/auth.service';
import { SessionContext } from '../../context/session.context';

export const LoginComponent = () => {

  const { logged, handleSession } = useContext(SessionContext);

  const history = useHistory();

  const { enqueueSnackbar } = useSnackbar();

  const [email, setEmail] = useState();

  useEffect(() => {
    if (logged) {
      history.push('/sales');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    setEmail(event.target.value);
  }

  const doLogin = async () => {
    try {
      const session = await login(email);
      console.log({ session });
      if (session.logged) {
        handleSession(session);
        enqueueSnackbar(`Bienvenido ${session.user.name}`, {
          variant: 'success',
          resumeHideDuration: 3000,
          anchorOrigin:
            { horizontal: 'right', vertical: 'bottom' }
        });
        history.push('/main');
      } else {
        window.alert(JSON.stringify(session));
        enqueueSnackbar('Acceso denegado', {
          variant: 'error',
          resumeHideDuration: 3000,
          anchorOrigin:
            { horizontal: 'right', vertical: 'bottom' }
        });
      }
    } catch (err) {
      enqueueSnackbar(JSON.stringify(err), {
        variant: 'error',
        resumeHideDuration: 3000,
        anchorOrigin:
          { horizontal: 'right', vertical: 'bottom' }
      });
    }
  }

  return (
    <Grid
      container
      jusfityContent="center"
      alignItems="center"
      spacing={2}
    >
      <Grid item xs={12}>
        <Grid container justifyContent="center">
          <Grid item onClick={() => history.push('/carta')}>
            <Button variant="outlined">Ver carta</Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <ViewerComponent>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item>
              <Typography variant="h3" align="center">
                Bienvenido
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <TextField
                variant="outlined"
                name="email"
                label="Correo electrónico"
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                startIcon={<LockIcon />}
                onClick={doLogin}
                disabled={!email}
              >
                Acceder con Google
              </Button>
            </Grid>
          </Grid>
        </ViewerComponent>
      </Grid>
    </Grid>
  );
}